




























































import Component from 'vue-class-component';
import Vue from 'vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import appInsights from '@/shared/services/appInsights';
import {Getter} from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
@Component({
	components: {
		FlowIcon
	}
})
export default class UpgradeModal extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public closeUpgradeModal() {
		this.$emit('close');
	}

	public chatWithUsClicked() {
		appInsights.trackEvent({ name: 'Upgrade modal: "chat with us" clicked' }, { workspaceId: this.currentWorkspace.id });
		window.open('https://www.netcall.com/liberty-connect-custom-flows-and-triage-bots?openConversation=true&utm_source=connect&utm_campaign=subscription_upgrade', '_blank');
	}
}
